import React, { memo } from 'react';
import { CardTypes } from '../../../enums';

const CardItem = ({ position = '', card, isRotated, highOrLowData, id }) => {
  return (
    <div
      className={`m-g-sm-cards-item ${card} ${position} ${
        position === ' ' && card !== CardTypes[0] ? highOrLowData[id] || '' : ''
      }`}
    >
      <div className={`mob-b-game-card ${isRotated}`}>
        <div className='mob-game-card-front' />
        <div className='mob-game-card-back' />
      </div>
    </div>
  );
};

export default memo(CardItem);
